import { DateRangeType } from "react-tailwindcss-datepicker";
import CustomDatePicker from "../awaitingInventory/CustomDatePicker";

interface DateRangeFilterProps {
  dates: DateRangeType;
  onDatesChange: (dates: DateRangeType) => void;
  dateFieldType: string;
  onDateFieldTypeChange: (type: string) => void;
  disabled?: boolean;
  className?: string;
}

export default function DateRangeFilter({
  dates,
  onDatesChange,
  dateFieldType,
  onDateFieldTypeChange,
  disabled = false,
  className = "",
}: DateRangeFilterProps) {
  return (
    <div className={`flex flex-wrap gap-x-6 items-center ${className}`}>
      <div className="flex items-center gap-x-2">
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Date Field</label>
          <select
            value={dateFieldType}
            onChange={(e) => onDateFieldTypeChange(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm"
            disabled={disabled}
          >
            <option value="Created">Created</option>
            <option value="ImagedOn">Imaged On</option>
            <option value="ListedDate">Listed On</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Date Range</label>
          <CustomDatePicker dates={dates} handleDatesChange={onDatesChange} />
        </div>
      </div>
    </div>
  );
}

